import React from 'react';
import CourseOutlineConfig from 'legacy-src/utility/CourseOutlineConfig';

const RouteWrapper = (WrappedComponent) =>
  CourseOutlineConfig((props) => {
    const {
      loading,
      courseOutlineConfig = {},
      isPreApSubject,
      hasFrqQuestions,
      assessment,
    } = props;
    const { libraryType } = assessment || {};
    if (loading) {
      return null;
    }

    /**
     * If no route exists after results/{id}/ decide where to redirect the user
     * */
    const { curriculumCheckTabLabel, ppcTagPair } =
      courseOutlineConfig.data || {};
    const isPPC =
      !hasFrqQuestions &&
      curriculumCheckTabLabel &&
      ppcTagPair &&
      !isPreApSubject &&
      libraryType === 'FYM';

    return (
      <WrappedComponent
        {...props}
        isPPC={isPPC}
        isPreApSubject={isPreApSubject}
        hasFrqQuestions={hasFrqQuestions}
      />
    );
  });

export default RouteWrapper;
